import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Printer, Instagram, Facebook } from "lucide-react";
import { hotel, navItems } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-[#221e18] text-white/80 font-body">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        {/* Brand */}
        <div className="md:col-span-1">
          <img src={hotel.logoWhite} alt={hotel.name} className="h-12 w-auto" />
          <p className="text-[14px] leading-relaxed text-white/55 mt-5">
            {hotel.descriptionShort}
          </p>
          <div className="flex gap-3 mt-6">
            <a href="#" className="w-9 h-9 flex items-center justify-center border border-white/20 hover:border-[#d9b877] hover:text-[#d9b877] transition-colors rounded-sm">
              <Instagram size={16} />
            </a>
            <a href="#" className="w-9 h-9 flex items-center justify-center border border-white/20 hover:border-[#d9b877] hover:text-[#d9b877] transition-colors rounded-sm">
              <Facebook size={16} />
            </a>
          </div>
        </div>

        {/* Links */}
        <div>
          <h4 className="eyebrow text-white mb-5 text-[11px]">Keşfet</h4>
          <ul className="space-y-3">
            {navItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className="text-[14px] text-white/60 hover:text-[#d9b877] transition-colors"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="md:col-span-2">
          <h4 className="eyebrow text-white mb-5 text-[11px]">İletişim</h4>
          <ul className="space-y-4 text-[14px] text-white/60">
            <li className="flex items-start gap-3">
              <MapPin size={17} className="text-[#d9b877] mt-0.5 shrink-0" />
              <span>{hotel.address}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={17} className="text-[#d9b877] shrink-0" />
              <span>{hotel.phones.join("  ·  ")}</span>
            </li>
            <li className="flex items-center gap-3">
              <Printer size={17} className="text-[#d9b877] shrink-0" />
              <span>Faks: {hotel.fax}</span>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={17} className="text-[#d9b877] shrink-0" />
              <span>{hotel.email}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 flex flex-col gap-4">
          <div className="flex flex-wrap justify-center md:justify-start gap-x-6 gap-y-2">
            <Link to="/gizlilik-politikasi" className="text-[12px] text-white/45 hover:text-[#d9b877] transition-colors" data-testid="footer-privacy">Gizlilik Politikası</Link>
            <Link to="/cerez-politikasi" className="text-[12px] text-white/45 hover:text-[#d9b877] transition-colors" data-testid="footer-cookies">Çerez Politikası</Link>
            <Link to="/kvkk" className="text-[12px] text-white/45 hover:text-[#d9b877] transition-colors" data-testid="footer-kvkk">KVKK Aydınlatma Metni</Link>
            <Link to="/kullanim-kosullari" className="text-[12px] text-white/45 hover:text-[#d9b877] transition-colors" data-testid="footer-terms">Kullanım Koşulları</Link>
          </div>
          <div className="flex flex-col md:flex-row items-center justify-between gap-3 border-t border-white/5 pt-4">
            <p className="text-[12px] text-white/40">
              © {new Date().getFullYear()} Safranbolu Çelebi Otel. Tüm hakları saklıdır.
            </p>
            <p className="text-[12px] text-white/40">UNESCO Dünya Mirası Safranbolu</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
